import dayjs from "utils/dayjs";

export const formatExcelDate = (excelDate: string) => {
  if (excelDate) {
    const date = new Date((parseInt(excelDate) - (25567 + 2)) * 86400);
    const unix = Math.floor(date.getTime() / 1000);
    return dayjs.unix(unix).format("YYYY-MM-DD");
  }

  return undefined;
};
